module.exports = __webpack_public_path__ + "img/KinokoTable42.54c98a5e.jpg";